import classNames from 'classnames';
import React from 'react';

import styles from './connection-label.module.css';

/** Creates a single-char label from given number */
export function ConnectionLabel(props: React.HTMLAttributes<HTMLSpanElement>) {
    return <span {...props} className={classNames(styles.root, props.className)} />;
}
